import { createContext, useContext, useEffect } from 'react';

// Lets the active page push the current course/lesson title up to the TopBar
// without prop drilling. AppShell provides the setter; pages call useShellTitle.
interface ShellTitleCtx {
  setTitle: (title: string | undefined) => void;
}

export const ShellTitleContext = createContext<ShellTitleCtx>({ setTitle: () => {} });

// Convenience hook: sets the TopBar title on mount and clears it on unmount.
export function useShellTitle(title: string | undefined) {
  const { setTitle } = useContext(ShellTitleContext);
  useEffect(() => {
    setTitle(title);
    return () => setTitle(undefined);
  }, [title, setTitle]);
}
